import { Clickable } from '@shared/Frontend/components/clickable'
import { SVGIconProps } from '@shared/Frontend/components/svg'
import * as React from 'react'
import { StyleguideExample, StyleguidePart } from '../../../../../Shared/Hoppinger.Styleguide/Frontend'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectsButtons = () => (
  <>
    <StyleguidePart title="Default" intro="As <button> and as <a>:">
      <StyleguideExample showExampleLabel={true} isFullScreen={false}>
        <ObjectButton label="Lorem ipsum" />
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart intro="Disabled:">
      <StyleguideExample showExampleLabel={true} isFullScreen={false}>
        <ObjectButton label="Lorem ipsum disabled" disabled />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectButton = (p: ObjectButtonProps) => (
  <>
    <Clickable
      elementKind="button"
      styleKind="button"
      onClick={() => {}}
      title={p.label}
      className={`outline-button ${p.extraClasses || ''}`}
      disabled={p.disabled}
      icon={p.icon}
    />
    <br />
    <br />
    <Clickable
      elementKind="link"
      styleKind="button"
      title={p.label}
      url="#"
      className={`outline-button ${p.extraClasses || ''}`}
      isExternal={false}
      disabled={p.disabled}
      icon={p.icon}
    />
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------          Types        ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

type ObjectButtonProps = {
  label: string
  icon?: SVGIconProps['id']
  extraClasses?: string
  disabled?: boolean
}
